import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay/PickersDay';
import ActivitiesIcon from '../../../src/assets/images/activities-icon.svg';
import { Row } from 'react-bootstrap';
import './binkiesCompliments.css';
import EventsDropdown from './EventsDropdown';
import MyBadge from '../common/MyBadge';
import Creations from '../../../src/assets/images/star-Creations.svg';
import flagIcon from '../../../src/assets/icon/icon-my-room-flag.svg';
import tribeIcon from '../../../src/assets/icon/Tribes.svg';
import captainIcon from '../../../src/assets/icon/Captains.svg';
import kidIcon from '../../../src/assets/icon/Kids.svg';
import CampCamps from '../views/camp_schedule/CampCamps';
import TribesDropdown from './TribesDropdown';
import { schoolViewModel } from '../views/school/school.view.model';
import { useAuth } from '../auth/Auth';
import { specialCampViewModel } from '../views/special_camp/special.camp.viewmodel';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#fff',
    boxShadow: 'none',
    padding: '0px !important',
  },
  avatar: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
  dsl: {
    backgroundColor: 'red',
  },
  selectedDay: {
    backgroundColor: '#ffeb3b', // Highlight color
    color: '#000', // Text color for highlighted days
  },
  icon: {
    paddingLeft: '15px',
    // paddingBottom: '5px'
  },
  header: {
    padding: '15px 22px',
    background: '#321B6D',
    // backgroundImage: linear - gradient(to right top, #6134d3, #5329bc, #49279f, #3d2185, #321b6d);
    borderRadius: '18px 18px 0px 0px',
  },
  ToggleButton: {
    border: 'none !important',
    padding: '7px !important',
  },
  calendarDiv1: {
    width: '100% !important',
    minWidth: '50%',
    alignItems: 'center',
    marginBottom: 'auto !important',
    marginTop: 'auto !important',
  },
  viewNotes: {
    padding: '25px',
    color: '#0066FF',
    display: 'flex',
    justifyContent: 'end',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  calendarTopSection: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  activityHeader: {
    color: '#fff !important',
  },
}));

const returnMonth = (date) => {
  const newDate = new Date(date);
  return newDate.getMonth() + 1;
};

function ServerDay(props) {
  const {
    highlightedDaysData = [],
    highlightedSpecialCampData,
    selectedEvent,
    day,
    outsideCurrentMonth,
    setSelectedDate,
    ...other
  } = props;
  const weekDays = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ];
  const isSelected =
    selectedEvent === 1
      ? !outsideCurrentMonth &&
      highlightedDaysData[0] === weekDays[day.getDay()]
      : selectedEvent === 2
        ? !outsideCurrentMonth &&
        highlightedSpecialCampData.length > 0 &&
        highlightedSpecialCampData[0].getMonth() === day.getMonth() &&
        highlightedSpecialCampData.findIndex(
          (item) => Number(item.getDate()) === day.getDate()
        ) !== -1
        : '';
  const isSelectedMood = isSelected
    ? selectedEvent === 1
      ? 'creative-camp'
      : selectedEvent === 2
        ? 'excited'
        : '  '
    : '';

  const handleSelect = () => {
    setSelectedDate(day.getDate());
  };

  return (
    <PickersDay
      {...other}
      outsideCurrentMonth={outsideCurrentMonth}
      day={day}
      className={
        isSelected ? `selected-day-${isSelectedMood}` : 'no-selected-day'
      }
      onClick={handleSelect}
    />
  );
}

const CampDashboardActivities = ({
  tribes,
  selectedTribe,
  setSelectedTribe,
  stepsEnabled,
}) => {
  const { school } = useAuth();
  const classes = useStyles();
  const currentDate = new Date();
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [selectedMonth, setSelectedMonth] = React.useState(
    currentDate.getMonth() + 1
  );
  const [selectedYear, setSelectedYear] = React.useState(
    currentDate.getFullYear()
  );
  const [selected, setSelected] = React.useState(new Date());
  const [highlightedDays, setHighlightedDays] = React.useState([]);
  const [highlightedDaysData, setHighlightedDaysData] = React.useState([]);
  const [highlightedSpecialCampData, setHighlightedSpecialCampData] =
    React.useState([]);
  const [selectedEvent, setSelectedEvent] = React.useState(1);
  const [badgeCount, setBadgeCount] = useState({});
  const [specialCamp, setSpecialCamp] = useState();
  const eventList = [
    { id: 1, name: 'Creative Camp' },
    { id: 2, name: 'Dream Camp' },
  ];

  const captainEventList = [{ id: 1, name: 'Creative Camp' }];

  const handleDateChange = (date) => {
    // console.log(date)
  };

  const handleMonthChange = (month) => {
    setSelectedMonth(month);
    setSelected(month);
    setSelectedDate(null);
  };

  const handleYearChange = (year) => {
    setSelectedYear(year);
    setSelected(year);
  };

  const getSpecialCamps = () => {
    if (school?.user_type === 'school') {
      specialCampViewModel
        .getSchoolUpcomingSpecialCamp(school?.id)
        .then((res) => {
          setSpecialCamp(res);
          if (res) {
            const date = new Date(res?.end_date_time);
            setHighlightedSpecialCampData([date]);
          } else {
            setHighlightedSpecialCampData([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getCreativeCamp = () => {
    setHighlightedDays([selectedTribe?.day]);
    setHighlightedDaysData([selectedTribe?.day]);
  };

  const getData = () => {
    getCreativeCamp();
  };

  useEffect(() => {
    getData();
  }, [selectedTribe]);

  useEffect(() => {
    if (!specialCamp?.id) getSpecialCamps();
  }, [selectedEvent]);

  const options = {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  const getBadgeCount = () => {
    let params = {};
    if (selectedTribe?.id !== 0) {
      params.tribe_id = selectedTribe?.id;
    }
    const API =
      school.user_type === 'school'
        ? schoolViewModel.getCampMasterBadgeCount
        : schoolViewModel.getCampCaptainBadgeCount;
    API(params)
      .then((res) => {
        setBadgeCount(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getBadgeCount();
  }, [selectedTribe]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container className={classes.root}>
        <Box
          className={classes.header}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Typography
            variant="h6"
            className={`compliments-received feeling-thoughts ${classes.activityHeader}`}
          >
            <img
              src={ActivitiesIcon}
              alt="Comment Icon"
              className={classes.icon}
            />
            Activities & Events
          </Typography>

          <Typography
            variant="h6"
            style={{
              marginRight: '10px',
              fontSize: '16px',
              color: '#fff',
              fontWeight: '700',
            }}
            color="#321B6D"
          >
            {currentDate.toLocaleDateString('en-GB', options)}
          </Typography>
        </Box>
        <Box
          className="moods-div camp-activity FullboxSize"
          display="flex"
          height="auto"
          justifyContent="end"
          alignItems="center"
          mb={3}
        >
          <div>
            <Box
              className="thoughts-box-div activity-dropdown-wrapper calendar-main"
              mt={1}
              display="flex"
              alignItems="center"
              style={{ width: '100%' }}
            >
              <Box className="thoughts-box row">
                <div
                  className="col-md-4 col-sm-4 mb-1"
                  id={
                    school.user_type === 'school'
                      ? 'step-five'
                      : 'captain-step-two'
                  }
                >
                  <TribesDropdown
                    selectedEvent={selectedTribe}
                    setSelectedEvent={setSelectedTribe}
                    eventList={tribes}
                  />
                </div>
                <div className="col-md-4 col-sm-6">
                  <EventsDropdown
                    selectedEvent={selectedEvent}
                    setSelectedEvent={setSelectedEvent}
                    stepsEnabled={stepsEnabled}
                    eventList={
                      school.user_type === 'school'
                        ? eventList
                        : captainEventList
                    }
                  />
                </div>
              </Box>
            </Box>
            <Row
              className="badge-wrapper kid-dashboard-manage"
              style={{ marginTop: '15px', marginLeft: '10px', width: '100%' }}
            >
              {selectedTribe?.id === 0 ? (
                <>
                  <div className="col-6 col-sm-2 mb-2">
                    <MyBadge
                      icon={tribeIcon}
                      className="first-badge mob-badge"
                      count={badgeCount?.tribe}
                      title={'Tribes'}
                    />
                  </div>
                  {school.user_type === 'school' && (
                    <div className="col-6 col-sm-2 mb-2">
                      <MyBadge
                        icon={captainIcon}
                        className="first-badge mob-badge"
                        count={badgeCount?.captain}
                        title={'Captains'}
                      />
                    </div>
                  )}
                  <div className="col-6 col-sm-2 mb-2">
                    <MyBadge
                      icon={kidIcon}
                      className="first-badge mob-badge"
                      count={badgeCount?.dependent}
                      title={'Kids'}
                    />
                  </div>
                  <div className="col-6 col-sm-2 mb-2">
                    <MyBadge
                      icon={flagIcon}
                      className="first-badge mob-badge"
                      count={badgeCount?.challenge}
                      title={'Challenges published'}
                    />
                  </div>
                  <div className="col-6 col-sm-2 mb-2">
                    <MyBadge
                      icon={Creations}
                      className="first-badge mob-badge"
                      count={badgeCount?.creation}
                      title={'Creations submitted'}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="col-6 col-sm-2 mb-2">
                    <MyBadge
                      icon={kidIcon}
                      className="first-badge mob-badge"
                      count={badgeCount?.dependent}
                      title={'Kids'}
                    />
                  </div>
                  <div className="col-6 col-sm-2 mb-2">
                    <MyBadge
                      icon={flagIcon}
                      className="first-badge mob-badge"
                      count={badgeCount?.challenge}
                      title={'Challenges published'}
                    />
                  </div>
                  <div className="col-6 col-sm-2 mb-2">
                    <MyBadge
                      icon={Creations}
                      className="first-badge mob-badge"
                      count={badgeCount?.creation}
                      title={'Creations submitted'}
                    />
                  </div>
                </>
              )}
            </Row>
          </div>
        </Box>
        <Paper className="calendardiv" elevation={3} sx={{ p: 1 }}>
          <CampCamps
            selectedTribe={selectedTribe}
            type={selectedEvent === 1 ? 'Creative' : 'Special'}
            specialCamp={specialCamp}
          />
          <Box
            sx={{
              width: '2px',
              height: '440px',
              backgroundColor: '#DFE0EB',
              margin: '0 20px',
            }}
            className="mobile-none tablet_none"
          />
          <DateCalendar
            className={classes.calendarDiv1}
            onChange={handleDateChange}
            onMonthChange={handleMonthChange}
            onYearChange={handleYearChange}
            views={['month', 'day']}
            slots={{
              day: ServerDay,
            }}
            slotProps={{
              day: {
                highlightedDaysData,
                highlightedSpecialCampData,
                selectedEvent,
                setSelectedDate: setSelectedDate,
              },
            }}
          />
        </Paper>
      </Container>
    </LocalizationProvider>
  );
};

export default CampDashboardActivities;
